<template>
  <div>
    <Bar :data="data" :options="options" />
  </div>
</template>

<script>
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  Colors,
} from "chart.js";
import { Bar } from "vue-chartjs";
import { ref } from "vue";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Colors
);

export default {
  name: "TotalSalesForYearReportGrapics",
  components: {
    Bar,
  },
  props: {
    datas: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    
    const labels = Object.keys(props.datas);
    const typePayments = Object.keys(props.datas[labels[0]]);

    const datasets = typePayments.map((typePayment) => ({
      label: typePayment.toUpperCase(),
      data: labels.map((mes) => props.datas[mes][typePayment])
    }));

    const data = ref({
      labels: labels,
      datasets: datasets,
    });
    //Configuracion de todas la opciones del gráfico de barra, como titulos, leyendas, etc.
    const options = ref({
      responsive: true,
      maintainAspectRatio: false, 
      plugins: {
        legend: {
          display: true,
        },
        colors: {
          enabled: true,
        },
        title: {
          display: true,
          text: "ventas del año actual".toUpperCase(),
        },
      },
    });
    return {
      data,
      options,
    };
  },
};
</script>
<style scoped>
canvas {
  height: 300px !important;
  width: 100% !important;
}
.chart-container {
  width: 100%;
  height: auto;
}
</style>
